<script setup lang="ts">
import { PhArrowSquareOut, PhCaretLeft, PhShieldCheck } from "@phosphor-icons/vue";

function validPrivacyPolicyUrl(value: string | undefined): string {
  if (!value) return "";
  try {
    const url = new URL(value);
    return url.protocol === "https:" ? url.toString() : "";
  } catch {
    return "";
  }
}

function bundledPrivacyPolicyUrl(): string {
  return globalThis.chrome?.runtime?.getURL?.("privacy.html") ?? "/privacy.html";
}

const privacyPolicyUrl = validPrivacyPolicyUrl(import.meta.env?.VITE_PRIVACY_POLICY_URL)
  || bundledPrivacyPolicyUrl();
</script>

<template>
  <section id="settingsView" class="settings-view" aria-labelledby="settingsViewTitle" hidden>
    <header class="view-header">
      <button id="settingsBackButton" class="icon-button" type="button" aria-label="返回素材总览">
        <PhCaretLeft :size="18" weight="bold" aria-hidden="true" />
      </button>
      <div class="view-title-group">
        <h2 id="settingsViewTitle">设置</h2>
        <span>显示与隐私</span>
      </div>
    </header>

    <div class="settings-content">
      <section class="settings-section" aria-labelledby="typographySettingsTitle">
        <div class="settings-font-row">
          <div class="settings-section-heading">
            <h3 id="typographySettingsTitle">界面字号</h3>
            <span id="settingsSaveStatus" class="settings-save-status" aria-live="polite"></span>
          </div>

          <fieldset class="settings-font-options">
            <legend class="visually-hidden">选择界面字号</legend>
            <label class="settings-font-option" for="typographyCompact">
              <input id="typographyCompact" name="popupTypography" type="radio" value="compact" />
              <strong>紧凑</strong>
            </label>
            <label class="settings-font-option" for="typographyStandard">
              <input id="typographyStandard" name="popupTypography" type="radio" value="standard" />
              <strong>标准</strong>
            </label>
            <label class="settings-font-option" for="typographyLarge">
              <input id="typographyLarge" name="popupTypography" type="radio" value="large" />
              <strong>大字</strong>
            </label>
          </fieldset>
        </div>
      </section>

      <section class="settings-privacy" aria-labelledby="privacySettingsTitle">
        <span class="settings-privacy-icon" aria-hidden="true">
          <PhShieldCheck :size="18" weight="bold" />
        </span>
        <div>
          <h3 id="privacySettingsTitle">隐私协议</h3>
          <p>了解数据如何处理</p>
        </div>
        <a :href="privacyPolicyUrl" target="_blank" rel="noreferrer">
          查看
          <PhArrowSquareOut :size="14" weight="bold" aria-hidden="true" />
        </a>
      </section>
    </div>
  </section>
</template>
